module.exports = __webpack_public_path__ + "img/ant.be5030ca.webp";